module.exports = require("@adc/constants");